<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">
                    {{ isViewMode ? '查看评标报告' : (isEditMode ? '编辑评标报告' : '添加评标报告') }}
                </h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回</el-button>
        </div>
        <div class="content-wrap">
            <el-form ref="evaluationForm" :model="formData" :rules="formRules" label-width="150px"
                class="evaluation-form">
                <!-- 标段名称 -->
                <el-form-item label="标段名称:" prop="bidSectionName" required>
                    <el-select v-model="formData.bidSectionCode" placeholder="请选择标段" style="width: 40%"
                        @change="handleSectionChange" :disabled="!!$route.query.bidEvaluationReportGuid">
                        <el-option v-for="item in sectionOptions" :key="item.bidSectionCode"
                            :label="item.bidSectionName" :value="item.bidSectionCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- 评标委员会负责人 -->
                <el-form-item v-if="formData.bidSectionCode" label="评标委员会负责人:" prop="committeeLeader">
                    <el-input v-model="formData.committeeLeader" placeholder="请输入评标委员会负责人"
                        style="width: 40%" :disabled="isViewMode"></el-input>
                </el-form-item>
                <!-- 评标报告标题 -->
                <el-form-item v-if="formData.bidSectionCode" label="评标报告标题:" prop="noticeName">
                    <el-input v-model="formData.noticeName" placeholder="请输入评标报告标题" style="width: 40%" :disabled="isViewMode"></el-input>
                </el-form-item>
                <!-- 评标委员会成员 -->
                <el-form-item v-if="formData.bidSectionCode" label="评标委员会成员:" prop="committeeMember">
                    <el-input v-model="formData.committeeMember" placeholder="请输入评标委员会成员" style="width: 40%" :disabled="isViewMode"></el-input>
                </el-form-item>
                <!-- 生成评标报告按钮 -->
                <el-form-item v-if="formData.bidSectionCode && !isViewMode">
                    <el-button type="success" @click="handleGenerateReport">生成评标报告</el-button>
                </el-form-item>
                <!-- 公告内容 -->
                <el-form-item label="公告内容:" prop="evaluationContent" >
                    <RichTextEditor v-model="formData.evaluationContent" :height="400" placeholder="请输入公告内容..."
                        toolbar-type="default" :disabled="isViewMode" />
                </el-form-item>
                <!-- 附件 -->
                <el-form-item label="附件:" prop="attachments">
                    <div class="attachment-section">
                        <div class="upload-area">
                            <el-button type="primary" @click="selectFile" :loading="uploading"
                                v-if="formData.uploadedFiles.length == 0 && !isViewMode">
                                {{ uploading ? '上传中...' : '选取文件' }}
                            </el-button>
                            <input ref="fileInput" type="file" style="display: none" @change="handleFileSelect"
                                accept=".pdf">
                        </div>
                        <div class="file-table">
                            <el-table :data="formData.uploadedFiles" style="width: 100%">
                                <el-table-column prop="fileName" label="文件名"></el-table-column>
                                <el-table-column prop="uploadTime" label="上传时间"></el-table-column>
                                <el-table-column prop="uploadProgress" label="上传进度" width="120">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.uploadProgress !== undefined">
                                            {{ scope.row.uploadProgress }}%
                                        </span>
                                        <span v-else>已完成</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="220">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small"
                                            @click="handleAttachmentDownload(scope.row)">
                                            下载
                                        </el-button>
                                        <el-button v-if="!isViewMode" type="text" size="small"
                                            @click="handleAttachmentDelete(scope.row, scope.$index)"
                                            style="color: #f56c6c;">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-form-item>
                <!-- 操作按钮 -->
                <el-form-item class="form-actions" v-if="!isViewMode">
                    <el-button @click="handleDraft" :loading="drafting">暂存</el-button>
                    <el-button type="primary" @click="handleSave" :loading="saving">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import { loadProjectDetail } from '@/utils/bid/projectInfo'
import { evaluationReportList, evaluationReportInit, evaluationReportAdd, evaluationReportDataDetail,createReportByTemplate } from '@/api/modules/evaluationReport'
import { getFileList, getFileDownloadList } from '@/api/modules/base'

import { deleteBidAtt } from '@/api/modules/make'
import { doFileUpload } from '@/utils/upload/fileUploadHelper'
import RichTextEditor from '@/components/common/RichTextEditor.vue'
export default {
    name: 'AddEvaluationReport',
    components: {
        RichTextEditor
    },
    data() {
        return {

            projectTitle: '',
            bidEvaluationReportGuid: '',
            uploading: false,
            saving: false,
            drafting: false,
            formData: {
                projectCode: this.$route.query.projectCode || '',
                bidSectionCode: '',
                bidSectionName: '', // 标段名称
                committeeLeader: '', // 评标委员会负责人
                committeeMember: '', // 评标委员会成员
                uploadedFiles: [], // 已上传文件列表
                noticeName: '',
                evaluationContent: '',
                fileGuid: '',
            },
            formRules: {
                bidSectionName: [
                    { required: true, message: '请选择标段名称' }
                ],
                noticeName: [
                    { required: true, message: '请输入评标报告标题' }
                ],
                committeeLeader: [
                    { required: true, message: '请输入评标委员会负责人' }
                ],
                committeeMember: [
                    { required: true, message: '请输入评标委员会成员' }
                ]
            },
            sectionOptions: [],
        }
    },
    computed: {
        isViewMode() {
            return this.$route.query.mode === 'view'
        },
        isEditMode() {
            return this.$route.query.mode === 'edit'
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        // 加载数据
        async loadData() {
            // 获取项目信息
            this.getProjectInfo()
            if (this.$route.query.bidEvaluationReportGuid) {
                await this.evaluationReportDataDetail(this.$route.query.bidEvaluationReportGuid)
                this.bidEvaluationReportGuid = this.$route.query.bidEvaluationReportGuid
            } else {
                //生成新的 fileGuid
                this.formData.fileGuid = new Date().getTime() + Math.random().toString().substr(2, 5)
            }

            // 加载标段列表
            this.fetchSectionList()
        },

        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.formData.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        // 评审报告详情
        async evaluationReportDataDetail(bidEvaluationReportGuid) {
            try {
                const res = await evaluationReportDataDetail(bidEvaluationReportGuid)
                if (res.code === 200) {
                    const data = res.data
                    console.log('-------评审报告详情');
                       console.log(data);
                          console.log('-------评审报告详情');
                    

                    // 填充表单数据
                    this.formData.bidSectionCode = data.bidSectionCode
                    this.formData.bidSectionName = data.bidSectionName
                    this.formData.noticeName = data.noticeName
                    this.formData.committeeLeader = data.committeeLeader
                    this.formData.committeeMember = data.committeeMember
                    this.formData.evaluationContent = data.evaluationContent
                    this.formData.fileGuid = data.fileGuid
                    if (data.fileGuid && data.fileGuid != '' && data.fileGuid != null) {
                        await this.loadUploadedFiles(data.fileGuid)
                    }
                    const otherFileGuids = Array.isArray(data.otherFileGuids) ? data.otherFileGuids : data.otherFileGuid
                    if (Array.isArray(otherFileGuids) && otherFileGuids.length > 0) {
                        for (const fileGuid of otherFileGuids) {
                            if (fileGuid && fileGuid != '' && fileGuid != null) {
                                await this.loadUploadedFiles(fileGuid, true)
                            }
                        }
                    }
                } else {
                    this.$message.error(res.msg || '获取评标报告详情失败')
                }
            } catch (error) {
                console.error('获取评标报告详情失败:', error)
                this.$message.error('获取评标报告详情失败')
            }
        },

        async loadUploadedFiles(fileGuid, append = false) {
            const res = await getFileList(fileGuid)
            if (res.code === 200) {
                this.formData.uploadedFiles = append ? this.formData.uploadedFiles.concat(res.data || []) : (res.data || [])
            } else {
                this.$message.error(res.msg)
            }
        },
        getAttachmentUrl(row) {
            const fileUrl = row && row.fileUrl
            if (!fileUrl) {
                this.$message.warning('文件下载地址不存在')
                return ''
            }
            return fileUrl
        },
        async handleAttachmentDownload(row) {
            try {
                const fileUrl = this.getAttachmentUrl(row)
                if (!fileUrl) {
                    return
                }
                const link = document.createElement('a')
                link.href = fileUrl
                link.download = row.fileName || '评标报告附件'
                link.target = '_blank'
                link.rel = 'noopener'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            } catch (error) {
                console.error('下载附件失败:', error)
                this.$message.error('下载附件失败')
            }
        },
        async handleAttachmentPrint(row) {
            try {
                const fileUrl = this.getAttachmentUrl(row)
                if (!fileUrl) {
                    return
                }
                const printWindow = window.open(fileUrl, '_blank')
                if (!printWindow) {
                    this.$message.warning('打印窗口被浏览器拦截，请允许弹窗后重试')
                    return
                }
                printWindow.onload = () => {
                    printWindow.print()
                }
            } catch (error) {
                console.error('打印附件失败:', error)
                this.$message.error('打印附件失败')
            }
        },
        // 获取标段列表
        async fetchSectionList() {
            try {
                const res = await evaluationReportList(this.formData.projectCode)
                if (res.code === 200) {
                    this.sectionOptions = res.data || []
                } else {
                    this.$message.error(res.msg || '获取标段列表失败')
                }
            } catch (error) {
                console.error('获取标段列表失败:', error)
                this.$message.error('获取标段列表失败')
            }
        },

        // 标段选择变化处理
        handleSectionChange(bidSectionCode) {
            this.formData.bidSectionCode = bidSectionCode
            if (bidSectionCode) {
                this.fetchCommitteeData(bidSectionCode)
                const isEditMode = !!this.$route.query.bidEvaluationReportGuid
                if (!isEditMode) {
                    const selectedSection = this.sectionOptions.find(item => item.bidSectionCode === bidSectionCode)
                    if (selectedSection) {
                        this.formData.noticeName = selectedSection.bidSectionName + '(评标报告)'
                        this.formData.bidSectionName = selectedSection.bidSectionName
                    }
                }
            }
        },
        // 初始化标段数据
        async fetchCommitteeData(bidSectionCode) {
            try {
                const res = await evaluationReportInit(bidSectionCode)
                if (res.code === 200) {
                    this.formData.committeeLeader = res.data.committeeLeader
                    this.formData.committeeMember = res.data.committeeMember
                } else {
                    this.$message.error(res.msg || '获取评委会数据失败')
                }
            } catch (error) {
                console.error('获取评委会数据失败:', error)
                this.$message.error('获取评委会数据失败')
            }
        },
        // 手动生成评估报告
        handleGenerateReport() {
            if (this.formData.bidSectionCode) {
                this.reportByTemplate(this.formData.bidSectionCode)
            } else {
                this.$message.warning('请先选择标段')
            }
        },
        
        async reportByTemplate(bidSectionCode) {
            try {
                const res = await createReportByTemplate({
                    bidSectionCode: bidSectionCode,
                })
                if (res.code === 200) {
                    const fileGuid = res.data
                    if (fileGuid) {
                        this.formData.fileGuid = fileGuid
                        const fileRes = await getFileDownloadList(fileGuid)
                        if (fileRes.code === 200 && fileRes.data) {
                            // 兼容性处理：无论返回的是数组还是单个对象，统一处理为数组
                            const fileList = Array.isArray(fileRes.data) ? fileRes.data : [fileRes.data]
                            if (fileList.length > 0) {
                                this.formData.uploadedFiles = fileList
                                this.$message.success('评标报告生成成功，已自动下载')
                                this.handleAttachmentDownload(fileList[0])
                                this.loadData()
                            } else {
                                this.$message.error('获取生成的评标报告文件详情为空')
                            }
                        } else {
                            this.$message.error('获取生成的评标报告文件详情失败')
                        }
                    } else {
                        this.$message.error('生成的报告标识为空')
                    }
                } else {
                    this.$message.error(res.msg || '生成评标报告失败')
                }
            } catch (error) {
                console.error('根据模版生成评标报告失败:', error)
                this.$message.error('根据模版生成评标报告失败')
            }
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 暂存
        handleDraft() {
            if (!this.formData.bidSectionCode) {
                this.$message.error('请选择标段名称')
                return
            }
            this.submitForm(0)
        },
        // 提交表单
        handleSave() {
            this.$refs.evaluationForm.validate((valid) => {
                if (!valid) {
                    this.$message.error('请检查表单填写是否完整')
                    return false
                }
                // 检查是否上传了文件
                if (!this.formData.uploadedFiles || this.formData.uploadedFiles.length === 0) {
                    this.$message.error('请上传评标报告扫描件')
                    return false
                }
                // 检查是否有文件正在上传
                const uploadingFile = this.formData.uploadedFiles.find(file => file.uploadProgress !== undefined && file.uploadProgress < 100)
                if (uploadingFile) {
                    this.$message.warning('请等待文件上传完成')
                    return false
                }
                this.submitForm(1)
            })
        },
        // 提交表单数据
        async submitForm(status) {
            const isDraft = status === 0
            if (isDraft) {
                this.drafting = true
            } else {
                this.saving = true
            }
            try {
                const submitData = { ...this.formData }
                submitData.status = status
                delete submitData.uploadedFiles
                const res = await evaluationReportAdd(submitData)
                if (res.code === 200) {
                    this.$message.success(isDraft ? '暂存成功！' : '提交成功！')
                    this.$router.go(-1)
                } else {
                    this.$message.error(res.msg || (isDraft ? '暂存失败' : '提交失败'))
                }
            } catch (error) {
                console.error(isDraft ? '暂存失败:' : '提交失败:', error)
                this.$message.error(isDraft ? '暂存失败，请重试' : '提交失败，请重试')
            } finally {
                this.drafting = false
                this.saving = false
            }
        },
        // 选择文件
        selectFile() {
            if (this.uploading) {
                this.$message.warning('请等待当前文件上传完成')
                return
            }
            if (!this.$route.query.bidEvaluationReportGuid) {
                this.formData.fileGuid = new Date().getTime() + Math.random().toString().substr(2, 5)
            }
            this.$refs.fileInput.click()
        },

        // 处理文件选择
        async handleFileSelect(event) {
            const file = event.target.files[0]
            if (!file) return

            // 检查文件类型
            const allowedTypes = ['.jpg', '.jpeg', '.png', '.pdf', '.doc', '.docx', '.zip', '.rar']
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase()
            if (!allowedTypes.includes(fileExtension)) {
                this.$message.error('文件类型不支持，请选择 jpg, png, pdf, doc, docx, zip, rar 格式的文件')
                event.target.value = ''
                return
            }
            // 检查文件大小 (限制为100MB)
            const maxSize = 100 * 1024 * 1024
            if (file.size > maxSize) {
                this.$message.error('文件大小不能超过100MB')
                event.target.value = ''
                return
            }
            // 添加到文件列表（先显示上传中状态）
            const fileInfo = {
                fileName: file.name,
                uploadTime: this.formatDateTime(new Date()),
                uploadProgress: 0,
                file: file
            }
            file.fileType = 'report'
            this.formData.uploadedFiles.push(fileInfo)
            const fileIndex = this.formData.uploadedFiles.length - 1
            // 开始上传
            this.uploading = true
            try {
                const result = await doFileUpload(file, {
                    fileBindId: this.formData.fileGuid,
                    onProgress: (percentage) => {
                        this.$set(this.formData.uploadedFiles[fileIndex], 'uploadProgress', Math.floor(percentage))
                    },
                    onSuccess: (uploadResult) => {
                        // 上传成功，更新文件信息
                        this.$set(this.formData.uploadedFiles[fileIndex], 'fileGuid', uploadResult.fileGuid)
                        this.$set(this.formData.uploadedFiles[fileIndex], 'uploadFileId', uploadResult.uploadFileId)
                        this.$set(this.formData.uploadedFiles[fileIndex], 'filePath', uploadResult.filePath)
                        this.$set(this.formData.uploadedFiles[fileIndex], 'uploadProgress', undefined)
                        this.$message.success('文件上传成功')
                    },
                    onError: (error) => {
                        console.error('文件上传失败:', error)
                        this.$message.error(error.message || '文件上传失败')
                        this.formData.uploadedFiles.splice(fileIndex, 1)
                    }
                })
                if (!result.success) {
                    throw new Error(result.message || '上传失败')
                }
            } catch (error) {
                console.error('文件上传异常:', error)
                // 确保失败的文件被移除
                const currentFile = this.formData.uploadedFiles[fileIndex]
                if (currentFile && currentFile.uploadProgress !== undefined) {
                    this.formData.uploadedFiles.splice(fileIndex, 1)
                }
            } finally {
                this.uploading = false
                // 清空input
                event.target.value = ''
            }
        },
        // 删除附件
        handleAttachmentDelete(row, index) {
            this.$confirm('确定要删除该文件吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                if (row.fileId) {
                    try {
                        const res = await deleteBidAtt(row.fileId)
                        if (res.code === 200) {
                            this.formData.uploadedFiles.splice(index, 1)
                            this.$message.success('文件删除成功')
                        } else {
                            this.$message.error(res.msg || '删除失败')
                        }
                    } catch (error) {
                        console.error('删除文件失败:', error)
                        this.$message.error('删除文件失败')
                    }
                } else {
                    this.formData.uploadedFiles.splice(index, 1)
                    this.$message.success('文件删除成功')
                }
            }).catch(() => {})
        },

        // 格式化日期时间
        formatDateTime(date) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-title {
    font-size: 16px;
    font-weight: 600;
    color: @gray-700;
    margin: 0;
    line-height: 1.5;
    position: relative;
    padding-left: 10px;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 16px;
        background: @primary-color;
        border-radius: 2px;
    }

    &:nth-child(2)::before {
        background: @gray-700;
    }
}

.content-wrap {
    background: #fff;
    padding: 30px;
    border-radius: 4px;
    box-shadow: @shadow-sm;
    margin-top: 20px;
    max-height: calc(100vh - 160px);
    overflow-y: auto;
}

.evaluation-form {
    text-align: start;

    .el-form-item {
        margin-bottom: 24px;

        .el-form-item__label {
            font-weight: 500;
            color: @gray-700;
            line-height: 32px;
        }

        .el-form-item__content {
            line-height: 32px;
        }

        &.is-required .el-form-item__label::before {
            content: '*';
            color: @error-color;
            margin-right: 4px;
        }
    }

    .el-input__inner,
    .el-textarea__inner {
        border-color: @gray-300;
        color: @gray-700;

        &:focus {
            border-color: @primary-color;
        }

        &::placeholder {
            color: @gray-400;
        }

        &:disabled {
            background-color: @gray-100;
            color: @gray-500;
        }
    }

    // 附件区域样式
    .attachment-section {
        .upload-tip {
            margin-bottom: 15px;
            font-size: 12px;
            color: @gray-500;
            text-align: left;
        }

        .upload-area {
            margin-bottom: 20px;
            text-align: start;

            .el-button {
                background: @primary-color;
                border-color: @primary-color;

                &:hover {
                    background: @primary-hover;
                    border-color: @primary-hover;
                }
            }
        }

        .file-table {
            width: 100%;

            .el-table {
                border: 1px solid @gray-200;
                border-radius: 4px;

                /deep/ .el-table__header {
                    th {
                        background-color: @gray-100;
                        color: @gray-700;
                        font-weight: 600;
                    }
                }
            }
        }
    }

    // 操作按钮区域
    .form-actions {
        text-align: center;
        padding-top: 30px;
        margin-top: 30px;
        border-top: 1px solid @gray-200;

        .el-form-item__content {
            display: flex;
            justify-content: center;
            gap: 20px;
        }

        .el-button {
            min-width: 100px;
            height: 40px;
            border-radius: 4px;
            font-size: 14px;

            &.el-button--primary {
                background-color: @primary-color;
                border-color: @primary-color;

                &:hover {
                    background-color: @primary-hover;
                    border-color: @primary-hover;
                }
            }

            &:not(.el-button--primary) {
                background-color: #fff;
                border-color: @gray-300;
                color: @gray-600;

                &:hover {
                    color: @primary-color;
                    border-color: @primary-color;
                    background-color: @primary-light;
                }
            }
        }
    }
}
</style>

